import { ClientPortalTranslate } from './clientPortalTranslate.model';

const clientPortalTranslatePTBR: ClientPortalTranslate = {
  loading: 'Abrindo seu portal…',
  greeting: 'Olá, {{name}}',
  subtitle: 'Tudo sobre o seu trabalho com {{studioName}} em um só lugar.',
  gate: {
    title: 'Confirme seu CPF',
    description:
      'Pra proteger seus dados, informe o CPF cadastrado com o estúdio.',
    documentLabel: 'CPF',
    submit: 'Acessar meu portal',
    error:
      'Não conseguimos abrir o portal. Confira o link e o CPF e tente novamente.',
    privacyNotice:
      'Usamos seu CPF apenas pra confirmar que este link é mesmo seu.',
    validation: {
      documentRequired: 'Informe seu CPF',
      documentInvalid: 'Informe um CPF válido',
    },
  },
  sections: {
    events: {
      title: 'Seus eventos',
      empty: 'Nenhum evento agendado por enquanto.',
      dateLabel: 'Data',
      locationLabel: 'Local',
      noDate: 'A combinar',
      noLocation: 'A combinar',
    },
    contracts: {
      title: 'Contratos',
      empty: 'Nenhum contrato disponível por enquanto.',
      issuedAt: 'Emitido em {{date}}',
      signedAt: 'Assinado em {{date}}',
      sign: 'Assinar contrato',
      expiresAt: 'Link válido até {{date}}',
      status: {
        ISSUED: 'Aguardando assinatura',
        SIGNED: 'Assinado',
      },
    },
    sales: {
      title: 'Pagamentos',
      empty: 'Nenhum pagamento registrado por enquanto.',
      total: 'Total {{value}}',
      installmentsCount: '{{count}}x',
      installmentLabel: 'Parcela {{number}}',
      dueDate: 'Vence em {{date}}',
      paidAt: 'Pago em {{date}}',
      status: {
        PENDING: 'A vencer',
        PAID: 'Pago',
        OVERDUE: 'Em atraso',
      },
    },
    galleries: {
      title: 'Galerias',
      empty: 'Nenhuma galeria publicada por enquanto.',
      photos: '{{count}} fotos',
      open: 'Abrir galeria',
      selectionLimit: 'Você pode escolher até {{count}} fotos',
      selectionConfirmed: 'Seleção confirmada em {{date}}',
    },
  },
  manage: {
    title: 'Portal do cliente',
    description:
      'Gere um link único pro cliente acompanhar contratos, pagamentos, eventos e galerias.',
    generate: 'Gerar link do portal',
    revoke: 'Revogar link',
    copy: 'Copiar link',
    tip: 'O cliente precisa confirmar o CPF cadastrado pra abrir o portal.',
    missingDocument:
      'Preencha o CPF do cliente na aba Contratos pra liberar o portal.',
    toast: {
      generated: 'Link do portal gerado',
      revoked: 'Link do portal revogado',
      linkCopied: 'Link copiado',
      linkCopyError: 'Não foi possível copiar o link',
      error: 'Não foi possível concluir a ação. Tente novamente.',
    },
    revokeConfirm: {
      title: 'Revogar o link do portal?',
      text: 'O link atual deixa de funcionar imediatamente.',
      secondaryText: 'Você pode gerar um novo link depois, se precisar.',
      confirm: 'Revogar',
      cancel: 'Cancelar',
    },
  },
};

export default clientPortalTranslatePTBR;
